import { adaklikCards } from '@/mocks/homeData';

export default function AdaklikSection() {
  return (
    <section id="adaklik" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-semibold mb-4">
              Adaklık Takip Sistemi
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
              Adaklık satış, kesim ve teslimat süreçlerini de aynı sistemde yönetin.
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-8">
              CiftlikWeb sadece Kurban Bayramı için değil, yıl boyunca devam eden adaklık satış ve kesim operasyonları için de kullanılabilir. Adaklık satışlarınızı, ödeme durumlarını, kesim bilgilerini ve teslimat süreçlerini kayıt altına alın.
            </p>
            <a
              href="#demo"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#demo')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-md hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Demo Talep Et
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>

          <div className="flex-1 w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {adaklikCards.map((card, i) => (
                <div
                  key={i}
                  className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-secondary-200/50 transition-all duration-300 group flex gap-3"
                >
                  <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center bg-secondary-50 rounded-lg group-hover:bg-secondary-100 transition-colors duration-300">
                    <i className={`${card.icon} text-secondary-600 text-base`}></i>
                  </div>
                  <div>
                    <h4 className="font-heading font-semibold text-sm text-foreground-950 mb-1">
                      {card.title}
                    </h4>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      {card.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}